import { createApi } from '@reduxjs/toolkit/query/react';
import { ReducerPaths } from '../../constants/reducerPaths';
import { baseQuery } from '../../utils/baseQuery';
import { validateCaptchaV3Token, validateCaptchaV2Token } from './mutations';

export const securityApi = createApi({
  reducerPath: ReducerPaths.SECURITY,
  baseQuery,
  tagTypes: ['security'],
  endpoints: (builder) => ({
    validateCaptchaV3Token: validateCaptchaV3Token(builder),
    validateCaptchaV2Token: validateCaptchaV2Token(builder),
  }),
});

export const {
  useValidateCaptchaV3TokenMutation,
  useValidateCaptchaV2TokenMutation,
} = securityApi;
